function buildCreateParams({ data, isDiscussionModule }) {
  // Keep parity with current index.js behavior:
  // - start from data.params (if undefined, spread yields {})
  // - add caption/fileId when present
  // - discussion: add fileId list from _discussionMeta.files
  const params = { ...data?.params };

  if (data?.caption) {
    params.caption = data.caption;
  }

  if (data?.fileId) {
    params.fileId = data.fileId;
  }

  if (isDiscussionModule && data?._discussionMeta?.files?.length > 0) {
    params.fileId = data._discussionMeta.files.map((f) => f.id);
  }

  return params;
}

function toDiscussionBody(data) {
  return typeof data?.content === 'string' ? data.content : String(data?.content ?? data?._discussionMeta?.body ?? '');
}

export const defaultStrategy = {
  prepareCreate({ module, data, pageId }) {
    const params = buildCreateParams({ data, isDiscussionModule: false });
    const contentToSend = data?.content;

    return {
      type: module.type.name,
      pageId,
      newRow: true,
      content: contentToSend,
      params,
    };
  },

  async update({ module, data, pageId, mutations }) {
    const { updatePageModule } = mutations;
    await updatePageModule({
      moduleId: module.id,
      pageId,
      content: data.content,
      params: data.params,
      sources: data.sources,
      caption: data.caption,
    }).unwrap();
  },
};

export const embedStrategy = {
  prepareCreate({ module, data, pageId }) {
    return {
      type: module.type.name,
      pageId,
      newRow: true,
      content: data?.content ?? [],
      params: data?.params,
      sources: data?.sources,
    };
  },

  async update({ module, data, pageId, mutations }) {
    const { updatePageModule } = mutations;
    await updatePageModule({
      moduleId: module.id,
      pageId,
      content: data?.content ?? [],
      params: data?.params,
      sources: data?.sources,
    }).unwrap();
  },
};

export const discussionStrategy = {
  prepareCreate({ module, data, pageId }) {
    const params = buildCreateParams({ data, isDiscussionModule: true });
    const body = toDiscussionBody(data);

    return {
      type: module.type.name,
      pageId,
      newRow: true,
      content: JSON.stringify({ body }),
      params,
    };
  },

  async update({ module, data, mutations }) {
    const { updateDiscussionContent } = mutations;

    const postId = module.data?.content?.id || module.params?.post_id;
    if (postId && data.content) {
      await updateDiscussionContent({
        id: postId,
        content: data.content,
      }).unwrap();
    }
  },
};

export const taskStrategy = {
  prepareCreate({ module, data, pageId }) {
    // Build params including task-specific fields: type and correctResponse

    const params = {
      caption: data?.caption,
      correctResponse: data?.correctResponse,
      taskType: data?.type,
    };

    return {
      type: module.type.name,
      pageId,
      newRow: true,
      params,

    };
  },

  async update({ module, data, pageId, mutations }) {
    const { updateTask } = mutations;

    const taskId = data.taskId || module.data?.params?.task?.taskId || module.data?.params?.taskId;
    if (!taskId) return;

    await updateTask({
      id: taskId,
      caption: data.caption,
      type: data.type,
      correctResponse: data.correctResponse,
      pageId,
    }).unwrap();
  },
};

const STRATEGIES = {
  embed: embedStrategy,
  discussion: discussionStrategy,
  task: taskStrategy,
  default: defaultStrategy,
};

export function getSaveStrategy(moduleType) {
  return STRATEGIES[moduleType] || STRATEGIES.default;
}
